<template>
  <svg
    width="17"
    height="16"
    viewBox="0 0 17 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.1552 5.33329H11.4885V3.99996C11.4885 2.15996 9.99517 0.666626 8.15517 0.666626C6.31517 0.666626 4.82184 2.15996 4.82184 3.99996V5.33329H4.15517C3.42184 5.33329 2.82184 5.93329 2.82184 6.66663V13.3333C2.82184 14.0666 3.42184 14.6666 4.15517 14.6666H12.1552C12.8885 14.6666 13.4885 14.0666 13.4885 13.3333V6.66663C13.4885 5.93329 12.8885 5.33329 12.1552 5.33329ZM8.15517 11.3333C7.42184 11.3333 6.82184 10.7333 6.82184 9.99996C6.82184 9.26663 7.42184 8.66663 8.15517 8.66663C8.8885 8.66663 9.4885 9.26663 9.4885 9.99996C9.4885 10.7333 8.8885 11.3333 8.15517 11.3333ZM10.2218 5.33329H6.0885V3.99996C6.0885 2.85996 7.01517 1.93329 8.15517 1.93329C9.29517 1.93329 10.2218 2.85996 10.2218 3.99996V5.33329Z"
      :fill="backgroundColor"
    />
  </svg>
</template>

<script>
export default {
    props: {
        backgroundColor: {
            type: String,
            default: "#2A8176"
        }
    }
}
</script>

<style>
</style>
